import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

class AlertSnack extends React.Component {
  render() {
    return (
      <Snackbar open={this.props.open} autoHideDuration={2000} onClose={this.props.onClose}>
        <Alert severity={this.props.tipo} sx={{ width: "100%" }} onClose={this.props.onClose}>
          {this.props.texto}
        </Alert>
      </Snackbar>
    );
  }
}

export default AlertSnack;
